import { Component, Input, OnChanges } from '@angular/core';
import { PointFeature } from '../../../../shared/models/GeoJson';
import { HardwareConfiguration, SensorType } from 'src/app/shared/models/vehicle.model';
import { ShiftWithDriverAndVehicleModel } from '../../../../shared/models/shift.model';
import { ConfigurationModel } from '../../../../shared/models/configuration.model';
import { DatePipe } from '@angular/common';
import { FormattingModule } from '../../../../shared/formatting/formatting.module';
import { LocationApiService } from '../../../../data/location-api/location-api.service';
import { MetricType } from '../../../../shared/models/session-metric.model';
import { ToastService } from '../../../../shared/services/toast.service';
import { DigitalSpreaderStatus } from '../../../live-map/models/asset.class';

@Component({
  selector: 'app-breadcrumb-info',
  imports: [
    DatePipe,
    FormattingModule
  ],
  templateUrl: './breadcrumb-info.component.html',
  styleUrl: './breadcrumb-info.component.scss'
})
export class BreadcrumbInfoComponent implements OnChanges {

  @Input() configuration: ConfigurationModel;
  @Input() shift: ShiftWithDriverAndVehicleModel;
  @Input() vehicleMarkerFeature: PointFeature;

  digitalGranularStatus: DigitalSpreaderStatus;
  digitalLiquidStatus: DigitalSpreaderStatus;

  HardwareConfiguration = HardwareConfiguration;
  SensorType = SensorType;

  constructor(
    private readonly locationApi: LocationApiService,
    private readonly toast: ToastService,
  ) {
  }

  ngOnChanges() {
    // TODO do not load when animating
    this.loadDigitalSpreaderStatus();
  }

  loadDigitalSpreaderStatus() {
    const hwConfig = this.shift.vehicleHardwareConfiguration;
    if (!!hwConfig && !!hwConfig.digitalSpreader) {
      if (hwConfig.digitalSpreader.settings.readGranular) {
        this.digitalGranularStatus = null;
        this.locationApi.closestSessionMetricEvent(
          this.shift.id,
          this.shift.vehicleId,
          MetricType.GRANULAR_RATE,
          +this.vehicleMarkerFeature.properties.unixtime,
        ).then(metric => {
          this.digitalGranularStatus = {
            controllerCurrentRate: metric?.data?.metricValue ?? 0,
            controllerMaxRate: hwConfig.digitalSpreader.settings.granularMaxRate,
          };
        }).catch(error => {
          console.error(error);
          this.toast.short('Failed to load Digital Spreader granular values!');
        });
      }

      if (hwConfig.digitalSpreader.settings.readLiquid) {
        this.digitalLiquidStatus = null;
        this.locationApi.closestSessionMetricEvent(
          this.shift.id,
          this.shift.vehicleId,
          MetricType.LIQUID_RATE,
          +this.vehicleMarkerFeature.properties.unixtime,
        ).then(metric => {
          this.digitalLiquidStatus = {
            controllerCurrentRate: metric?.data?.metricValue ?? 0,
            controllerMaxRate: hwConfig.digitalSpreader.settings.granularMaxRate,
          };
        }).catch(error => {
          console.error(error);
          this.toast.short('Failed to load Digital Spreader liquid values!');
        });
      }
    }
  }
}
